// extracted by mini-css-extract-plugin
export default {"Service__Section":"Service_Service__Section__xW7jA","Icon__Box":"Service_Icon__Box__KMcJ2","Icon":"Service_Icon__mP-pa","Title":"Service_Title__e+b3y"};